import axios from 'axios';

// Resources for /posts endpoint on API
// @see https://github.com/mzabriskie/axios#creating-an-instance
export const apiClient = axios.create({
    baseURL: Global.BASE_URL,
});

export const fileUploadClient = axios.create({
    baseURL: Global.BASE_URL,
    headers: {
        'Content-Type': 'multipart/form-data',
    }
});
